module.exports = __webpack_public_path__ + "img/0x18e68f649f27719c185ae3d13098163336ec2f8c.e1905e6e.png";